import { grupoService } from '../services/grupo.service.js';

import { store } from './store.js';

import { SET_GRUPOS, SET_LOADING, SET_EMPTY,SET_DYNAMIC_MODAL,REMOVE_GROUP,SET_SAVING,UPDATE_ACTIVITY_POSITIONS  } from "./grupo.reducer.js";
import { SET_INFOMODULO } from "./infomodulos.reducer.js";




// Acción para actualizar el orden de las actividades
export async function updateActivityOrder(groupId, updatedGrupos) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Indicar que se está guardando

    try {
        // Obtener el grupo que se actualizó
        const grupoActualizado = updatedGrupos.find(grupo => grupo.id_grupo === groupId);

        // Arreglo para almacenar la información que se enviará a la API
        const actividadesAActualizar = [];

        // Actualizar cada actividad en el backend con su nueva posición
        for (const actividad of grupoActualizado.actividades) {
            const { id_actividad, posicion_elemento, fk_grupo_id } = actividad;

            // Construir el objeto para cada actividad con su id, fk_grupo_id, y nueva posición
            actividadesAActualizar.push({
                id_actividad,
                fk_grupo_id,
                posicion_elemento
            });

          
            
           
        }
         await grupoService.UpdatepositionTask(actividadesAActualizar);
    

        // Obtener el estado actual
        const { grupos } = store.getState().grupoModule;

        // Actualizar el estado local después de guardar los cambios
        const nuevosGrupos = grupos.map(grupo => {
            return grupo.id_grupo === groupId ? grupoActualizado : grupo;
        });

        store.dispatch({ type: UPDATE_ACTIVITY_POSITIONS, grupos: nuevosGrupos });
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finalizar la carga

    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finalizar la carga
        console.error('Error updating activity order:', err);
        throw err;
    }
}


export async function updateSubActivityOrder(activityId, subactividadesActualizadas, groupId) {
    const _ = require('lodash');
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Indicar que se está guardando
    try {
        if (!Array.isArray(subactividadesActualizadas)) {
            throw new Error('subactividadesActualizadas no es un arreglo.');
        }

        // Preparar la información para la API
        const subactividadesAActualizar = subactividadesActualizadas.map(({ id_subactividad, fk_actividad_id, posicion_elemento }) => ({
            id_subactividad,
            fk_actividad_id,
            posicion_elemento
        }));

        // Obtener el estado actual
        const { grupos } = store.getState().grupoModule;
        const gruposCopy = _.cloneDeep(grupos);

        // Encontrar el grupo correcto donde se actualizarán las subactividades
        const updatedGrupos = gruposCopy.map((grupo, groupIndex) => {
            if (grupo.id_grupo === groupId) {
            // Encontrar la actividad correcta dentro del grupo
            const updatedActividades = grupo.actividades.map((actividad, actividadIndex) => {
                if (actividad.id_actividad === activityId) {
                // Reemplazar las subactividades con las subactividadesActualizadas
                return { ...actividad, subactividades: subactividadesActualizadas };
                }
                return actividad;
            });
            return { ...grupo, actividades: updatedActividades };
            }
            return grupo;
        });

        // Llamar a la API para actualizar las posiciones de las subactividades
        // console.log(updatedGrupos)
        store.dispatch({ type: SET_GRUPOS, grupos: updatedGrupos });
        await grupoService.UpdatepositionSubTask(subactividadesAActualizar);

        // Despachar la acción para actualizar las posiciones de actividades y subactividades
        // store.dispatch({ type: UPDATE_ACTIVITY_POSITIONS, grupos });


    } catch (err) {
        console.error('Error updating subactivity order:', err);
    } finally {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finalizar la carga
    }
}


export async function CargarInfoModulos(id_region) {
    try {

        const infoModulos = await grupoService.getDataModulos(id_region);
        store.dispatch( { type: SET_INFOMODULO, infoModulos } );

    } catch (err) {
        throw err
    }
}

//Funcion para traer los usuarios de un tablero
export async function getTableroUsers(id_tablero) {
    try {
       
        const infoModulos = await grupoService.getUserTablero(id_tablero);
       
return infoModulos;

    } catch (err) {
        throw err
    }
}

//Funcion para asignar un usuario a un tablero
export async function saveAssingTablero(tableroDetalle) {
    try {
       
   const assing = await grupoService.assignUserBoard(tableroDetalle);

   return assing;
    } catch (err) {
        throw err
    }
}




export function setSaving(isSaving) {
    return { type: SET_SAVING, isSaving };
}

//Funcion Reutilizable 
export function setDynamicModalObj2(dynamicModalObj) {
    
    store.dispatch({ type: SET_DYNAMIC_MODAL, dynamicModalObj })
}

    export async function GeneralQueryActions(endpoint, params) {
        try {
            store.dispatch({ type: SET_GRUPOS, grupos: [] });
            store.dispatch({ type: SET_LOADING, isLoading: true });            
    
            const grupos = await grupoService.getGroupsWithParams(endpoint, params);
            store.dispatch({ type: SET_GRUPOS, grupos});

            store.dispatch({ type: SET_LOADING, isLoading: false });            
            store.dispatch({ type: SET_EMPTY, isEmpty: (grupos === undefined || grupos === null || grupos.length === 0) });

        } catch (err) {
            throw err;
        }
    }


export async function loadGroupsWithActivities(idTablero) {
    try {

        const grupos = await grupoService.getGroupsWithActivities(idTablero);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}



//Eliminar luego de revision 
export async function loadGroupsWithUactividades(idTablero) {
    try {
        
        const grupos = await grupoService.getGroupsWithActivities(idTablero);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}


//Cargar por lista de usuarios
export async function loadGroupsListaUsuarios(idTablero, listaUsuarios) {
    try {
        // Convertir la lista de usuarios a una cadena separada por comas
        const idUsuarios = listaUsuarios.join(',');
        
      
        
        const grupos = await grupoService.getGroupslistaUsuarios(idTablero, idUsuarios);

        store.dispatch({ type: SET_GRUPOS, grupos });
    } catch (err) {
        throw err;
    }
}

// cargar los datos con los tableros y proyecto 
export async function loadGroupsWithProyectos(idTablero,idUsuario, idProyecto) {
    try {
        store.dispatch( { type: SET_GRUPOS, grupos : [] } );

        const grupos = await grupoService.getGroupsWithProyecto(idTablero,idUsuario,idProyecto);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}




// cargar los datos con los tableros y proyecto 
export async function loadGroupsWithResponsable(idTablero,idUsuario) {
    try {
        store.dispatch( { type: SET_GRUPOS, grupos : [] } );

        const grupos = await grupoService.getGroupsWithUsuarios(idTablero,idUsuario);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}




export async function saveNewTask(task, groupId) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        const respuesta = await grupoService.guardarActividad(task);
        
        const { grupos } = store.getState().grupoModule;

        grupos.forEach((grupo, index) => {
            if (grupo.id_grupo === groupId) {
                grupos[index].actividades.push(respuesta);
            }
        });

        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        throw err;
    }
}





//Funcion para actualizar una actividad
export async function updateTask(task) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        const { grupos } = store.getState().grupoModule;

        grupos.forEach((grupo, groupIndex) => {
            grupo.actividades.forEach((actividad, taskIndex) => {
                if (actividad.id_actividad === task.id_actividad) {
                    grupos[groupIndex].actividades[taskIndex] = task;
                }
            });
        });

        await grupoService.actualizarActividad(task);
        store.dispatch({ type: SET_SAVING, isSaving: false });
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false });
        console.error('Error al actualizar la tarea:', err);
        throw err;
    }
}

// Función para actualizar una sub-actividad
export async function updateSubTask(subTask) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        const { grupos } = store.getState().grupoModule;

        grupos.forEach((grupo, groupIndex) => {
            grupo.actividades.forEach((actividad, taskIndex) => {
                actividad.subactividades.forEach((subActividad, subTaskIndex) => {
                    if (subActividad.id_subactividad === subTask.id_subactividad) {
                        grupos[groupIndex].actividades[taskIndex].subactividades[subTaskIndex] = subTask;
                    }
                });
            });
        });
        await grupoService.actualizarSubActividad(subTask);
        store.dispatch({ type: SET_SAVING, isSaving: false });
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false });
        console.error('Error al actualizar la sub-actividad:', err);
        throw err;
    }
}



//funcion de pruebas funcional 
export async function saveNewSubTask(subtask, groupId, actividadId) {
    // Inicia la carga (loading state)
    store.dispatch({ type: SET_SAVING, isSaving: true });

    try {
        // Guardar la nueva subactividad en la base de datos
        const respuesta = await grupoService.guardarSubActividad(subtask); 
        
        // Obtener el estado actual de los grupos desde Redux
        const { grupos } = store.getState().grupoModule;

        // Encontrar el grupo correcto donde se agregará la subactividad
        grupos.forEach((grupo, groupIndex) => {
            if (grupo.id_grupo === groupId) {
                // Encontrar la actividad correcta dentro del grupo
                grupo.actividades.forEach((actividad, actividadIndex) => {
                    if (actividad.id_actividad === actividadId) {
                        // Agregar la nueva subactividad a la actividad correspondiente
                        grupos[groupIndex].actividades[actividadIndex].subactividades.push(respuesta);
                    }
                });
            }
        });

        // Actualizar el estado en Redux con los grupos modificados
        store.dispatch({ type: SET_GRUPOS, grupos });
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga

        return respuesta; // Retornar la subactividad guardada como respuesta
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga en caso de error
        throw err;
    }
}

//------------FUNCIONES PARA VISUALIZAR Y RESTABLECER ACTIVIDADES Y SUB ACTIVIDADES ELIMINADAS------ 

//Funcion para restablecer una actividad eliminadaa:
export async function resetDeletedTask(task, groupId) {

    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    delete task.nombre_grupo;
    task.archivada = 0;  // Establecer el campo archivada a 0

    try {
        
        const success = await grupoService.resetTaskDelete(task.id_actividad);
        console.log(task);
        if (success) {
            const { grupos } = store.getState().grupoModule;

            grupos.forEach((grupo, index) => {
                if (grupo.id_grupo === groupId) {
                    grupos[index].actividades.push(task);
                }
            });

            store.dispatch({ type: SET_GRUPOS, grupos });
            console.log(grupos);
        }
        // Finaliza la carga independientemente del resultado
        
        
        store.dispatch({ type: SET_SAVING, isSaving: false });
        return success; // Retorna el resultado de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga en caso de error
        throw err; // Propagar el error para manejarlo fuera de la función
    }
}



//Funcion para llamar las  actividad eliminadaa:
export async function viewtaskdelete(id_tablero) {
   
    
    try {
        const respuesta = await grupoService.viewTaskdelete(id_tablero);
        

       
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
       
        throw err;
    }
}


//Funcion para llamar las  sub actividades eliminadas:
export async function viewsubtaskdelete(id_tablero) {
   
    
    try {
        const respuesta = await grupoService.viewsubTaskdelete(id_tablero);
        

       
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
       
        throw err;
    }
}

//funcion para restablecer las subactividades eliminadas
export async function resetDeletedSubTask(subtask) {
     // Inicia la carga (loading state)
     store.dispatch({ type: SET_SAVING, isSaving: true });
    // Extraer los valores de fk_actividad_id y fk_grupo_id
    const fkActividadId = subtask.fk_actividad_id;
    const fkGrupoId = subtask.fk_grupo_id;
    // Establecer el campo archivada a 0
    subtask.archivada = 0; // <-- Cambio aquí
    // Eliminar el campo fk_grupo_id del objeto subtask
    delete subtask.fk_grupo_id;
    delete subtask.nombre_grupo;

    try {
        // Guardar la nueva subactividad en la base de datos
        const success = await grupoService.resetSubTaskDelete(subtask.id_subactividad); 
        
        if (success) {
        // Obtener el estado actual de los grupos desde Redux
        const { grupos } = store.getState().grupoModule;

        // Encontrar el grupo correcto donde se agregará la subactividad
        grupos.forEach((grupo, groupIndex) => {
            if (grupo.id_grupo === fkGrupoId) {
                // Encontrar la actividad correcta dentro del grupo
                grupo.actividades.forEach((actividad, actividadIndex) => {
                    if (actividad.id_actividad === fkActividadId) {
                        // Agregar la nueva subactividad a la actividad correspondiente
                        grupos[groupIndex].actividades[actividadIndex].subactividades.push(subtask);
                    }
                });
            }
        });

        // Actualizar el estado en Redux con los grupos modificados
        store.dispatch({ type: SET_GRUPOS, grupos });
    }
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga

        // return respuesta; // Retornar la subactividad guardada como respuesta
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga en caso de error
        throw err;
    }
}

//------------FIN--------------



export async function archivarElementos(ids, context) {
    try {
        if (context === "actividades" || context === "subactividades") {
            await grupoService.archivarActividad(ids, context);
        }
    } catch (err) {
        console.log('UserActions: error in archivarElementos', err);
    }
}



export async function updateAfterDelete(ids, context) {
    const _ = require('lodash');
    const { grupos } = store.getState().grupoModule;
    const gruposCopy = _.cloneDeep(grupos);

    if (context === "actividades") {
        const filteredGroups = gruposCopy.map(grupo => {
            return {
                ...grupo,
                actividades: grupo.actividades.filter(actividad => !ids.includes(actividad.id_actividad))
            };
        });

        store.dispatch({ type: SET_GRUPOS, grupos: filteredGroups });

    } else if (context === "subactividades") {
        const filteredGroups = gruposCopy.map(grupo => {
            return {
                ...grupo,
                actividades: grupo.actividades.map(actividad => {
                    return {
                        ...actividad,
                        subactividades: actividad.subactividades.filter(subactividad => !ids.includes(subactividad.id_subactividad))
                    };
                })
            };
        });

        store.dispatch({ type: SET_GRUPOS, grupos: filteredGroups });
    }
}




export async function movetask(idgroup, idstask) {
    try {
        await grupoService.movetaskgroup(idgroup, idstask);

        const { grupos } = store.getState().grupoModule;

        const updatedGrupos = grupos.map(grupo => {
            const updatedActividades = grupo.actividades.filter(act => !idstask.includes(act.id_actividad));
            return { ...grupo, actividades: updatedActividades };
        });

        const targetGrupoIndex = grupos.findIndex(grupo => grupo.id_grupo === idgroup);

        if (targetGrupoIndex !== -1) {
            idstask.forEach(taskId => {
                const movedTask = grupos.flatMap(grupo => grupo.actividades).find(act => act.id_actividad === taskId);
                if (movedTask) {
                    updatedGrupos[targetGrupoIndex].actividades.push(movedTask);
                }
            });
        }

        store.dispatch({ type: SET_GRUPOS, grupos: updatedGrupos });
    } catch (err) {
        console.error('Error moving tasks:', err);
        throw err;
    }
}


//Convertir Sub actividad en Actividad principal

export async function ConverSubTask(groupId, idSubTask) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        const respuesta = await grupoService.converSubTask(groupId,idSubTask);
        
        const { grupos } = store.getState().grupoModule;

        grupos.forEach((grupo, index) => {
            if (grupo.id_grupo === groupId) {
                grupos[index].actividades.push(respuesta);
            }
        });

        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        throw err;
    }
}

//AQUI VAMOSSS



//FUNCION PARA FILTRAR LAS ACTIVIDADES CON EL FILTRO NORMAL:
export async function filterAvanceTask(formData,idTablero,filtroDate) {
    try {
        store.dispatch( { type: SET_GRUPOS, grupos : [] } );

        const grupos = await grupoService.FilterAvanceTask(formData,idTablero,filtroDate);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}

//FUNCION PARA FILTRAR LAS ACTIVIDADES POR RESPONSABLE EN EL FILTRO GENERAL:
export async function filterAvanceTaskUsers(formData,idTablero,idResponsable,filtroStatus) {
    try {
        store.dispatch( { type: SET_GRUPOS, grupos : [] } );

        const grupos = await grupoService.FilterAvanceTaskUsers(formData,idTablero,idResponsable,filtroStatus);

        store.dispatch( { type: SET_GRUPOS, grupos } );

    } catch (err) {
        throw err
    }
}





//-----------------------FUNCIONES GRUPOS--------------------

//Guardar grupo
export async function addGroupToApi(newGroup) {
    try {
        
        const { grupos } = store.getState().grupoModule;
        const emptyGroup = grupoService.getEmptyGroup2();
        // const groupToAdd = { ...emptyGroup, ...newGroup };

        const addedGroup = await grupoService.AgregarGrupo(newGroup);
        const groupToAdd = { ...emptyGroup, ...addedGroup };

       
        grupos.push(groupToAdd);

        store.dispatch({
            type: SET_GRUPOS,
            grupos: [...grupos],
        });
    } catch (err) {
        console.error('Error al agregar el grupo:', err);
        throw err;
    }
}


export async function updateGrupoAction(groupId, updatedGroup) {
    try {
      
        const { grupos } = store.getState().grupoModule;

        const groupIndex = grupos.findIndex(g => parseInt(g.id_grupo) === parseInt(groupId));
        
        if (groupIndex !== -1) {
            // Actualiza el grupo en el estado local

            grupos[groupIndex] = {...grupos[groupIndex], ...updatedGroup};
            
            // Realiza una llamada a la API para actualizar el grupo en el servidor
            await grupoService.actualizarGrupo(groupId, updatedGroup);
        } else {
            throw new Error('Group not found');
        }
    } catch (err) {
        console.error('Error al actualizar el grupo:', err);
        throw err;
    }
}


//funcion par duplicar grupos

export async function duplicateGroupInApi(idTablero, idGrupo) {
    try {
        const { grupos } = store.getState().grupoModule;
        const duplicatedGroup = await grupoService.DuplicarGrupo(idTablero, idGrupo);
        const emptyGroup = grupoService.getEmptyGroup2();
        const groupToAdd = { ...emptyGroup, ...duplicatedGroup };
        
        grupos.push(groupToAdd);

        store.dispatch({
            type: SET_GRUPOS,
            grupos: [...grupos],
        });
    } catch (err) {
        console.error('Error al duplicar el grupo:', err);
        throw err;
    }
}


//Remover Grupo
export async function removeGroup(idGrupo,idTablero) {
    try {
        await grupoService.MoverGrupoaTablero(idGrupo, idTablero)
        store.dispatch({ type: REMOVE_GROUP, idGrupo })
    } catch (err) {
        console.log('cant remove', err)
        throw err
    }
}

//FUNCIONES PARA MEDIOS DE VERIFICACION

export async function saveMedioVeficiacion(file, groupId, actividadId) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        // Guarda el archivo en la API
        const respuesta = await grupoService.guardarArchivos(file);
        console.log("respuesta",respuesta);

        // Obtiene el estado actual de los grupos
        const { grupos } = store.getState().grupoModule;

        // Busca el grupo por su ID
        const grupo = grupos.find(grupo => grupo.id_grupo === groupId);

        if (grupo) {
            // Busca la actividad dentro del grupo por su ID
            const actividad = grupo.actividades.find(
                actividad => actividad.id_actividad === actividadId
            );

            if (actividad) {
                // Agrega el nuevo archivo a "archivosactividad"
                if (!Array.isArray(actividad.archivosactividad)) {
                    actividad.archivosactividad = [];
                }
                actividad.archivosactividad.push(respuesta);
            } else {
                console.error("Actividad no encontrada");
            }
        } else {
            console.error("Grupo no encontrado");
        }

        // Actualiza el estado global con los nuevos cambios
        store.dispatch({ type: SET_GRUPOS, grupos: [...grupos], // Crea una copia del arreglo actualizado
        });
        console.log(grupos);

        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        throw err;
    }
}

//FUNCION PARA ACTUALIZAR UN MEDIO DE VERIFICACION
export async function updateMedioVerificacion(updatedFile,id_remplaza, groupId,actividadId,archivoId) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        // Llama a la API para actualizar el archivo
        const respuesta = await grupoService.EvaluacionMVerificacion(updatedFile, id_remplaza);

        console.log("respuesta API",respuesta.data);

        // Obtiene el estado actual de los grupos
        const { grupos } = store.getState().grupoModule;

        // Busca el grupo por su ID
        const grupo = grupos.find(grupo => grupo.id_grupo === groupId);

        if (grupo) {
            // Busca la actividad dentro del grupo por su ID
            const actividad = grupo.actividades.find(
                actividad => actividad.id_actividad === actividadId
            );

            if (actividad) {
                // Encuentra el archivo a actualizar dentro de "archivosactividad"
                const archivoIndex = actividad.archivosactividad.findIndex(
                    archivo => archivo.id_archivo_actividad === archivoId
                );

                if (archivoIndex !== -1) {
                    // Actualiza el archivo existente con la nueva respuesta
                    actividad.archivosactividad[archivoIndex] = respuesta.data;
                } else {
                    console.error("Archivo no encontrado en la actividad");
                }
            } else {
                console.error("Actividad no encontrada");
            }
        } else {
            console.error("Grupo no encontrado");
        }

        // Actualiza el estado global con los nuevos cambios
        store.dispatch({
            type: SET_GRUPOS,
            grupos: [...grupos], // Crea una copia del arreglo actualizado
        });
        console.log(grupos);
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        throw err; // Lanza el error
    }
}

//FUNCION PARA ACTUALIZAR UN MEDIO DE VERIFICACION
export async function RemplaceMedioVerificacion(RemplaceFile,id_Archivo, groupId,actividadId) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        // Llama a la API para actualizar el archivo
        const respuesta = await grupoService.RemplazarArchivos(RemplaceFile, id_Archivo);
        // Obtiene el estado actual de los grupos
        const { grupos } = store.getState().grupoModule;

        // Busca el grupo por su ID
        const grupo = grupos.find(grupo => grupo.id_grupo === groupId);

        if (grupo) {
            // Busca la actividad dentro del grupo por su ID
            const actividad = grupo.actividades.find(
                actividad => actividad.id_actividad === actividadId
            );

            if (actividad) {
                // Encuentra el archivo a actualizar dentro de "archivosactividad"
                const archivoIndex = actividad.archivosactividad.findIndex(
                    archivo => archivo.id_archivo_actividad === id_Archivo
                );

                if (archivoIndex !== -1) {
                    // Actualiza el archivo existente con la nueva respuesta
                    actividad.archivosactividad[archivoIndex] = respuesta.data;
                } else {
                    console.error("Archivo no encontrado en la actividad");
                }
            } else {
                console.error("Actividad no encontrada");
            }
        } else {
            console.error("Grupo no encontrado");
        }

        // Actualiza el estado global con los nuevos cambios
        store.dispatch({
            type: SET_GRUPOS,
            grupos: [...grupos], // Crea una copia del arreglo actualizado
        });
    
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta; // Retorna la respuesta de la API
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        throw err; // Lanza el error
    }
}

//Funcion para eliminar un archivo del redux

export async function deleteMedioVerificacion( id_archivo, groupId, actividadId) {
    store.dispatch({ type: SET_SAVING, isSaving: true }); // Inicia la carga
    try {
        // Llama a la API para eliminar el archivo (opcional si tienes una API que maneja esto)
        const respuesta = await grupoService.deshabilitarArchivos(id_archivo); // Reemplaza esto con la función de tu API

        // Obtiene el estado actual de los grupos
        const { grupos } = store.getState().grupoModule;

        // Busca el grupo por su ID
        const grupo = grupos.find(grupo => grupo.id_grupo === groupId);

        if (grupo) {
            // Busca la actividad dentro del grupo por su ID
            const actividad = grupo.actividades.find(
                actividad => actividad.id_actividad === actividadId
            );

            if (actividad) {
                // Filtra el archivo a eliminar dentro de "archivosactividad"
                actividad.archivosactividad = actividad.archivosactividad.filter(
                    archivo => archivo.id_archivo_actividad !== id_archivo
                );
            } else {
                console.error("Actividad no encontrada");
            }
        } else {
            console.error("Grupo no encontrado");
        }

        // Actualiza el estado global con los nuevos cambios
        store.dispatch({
            type: SET_GRUPOS,
            grupos: [...grupos], // Crea una copia del arreglo actualizado
        });

        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        return respuesta;
    } catch (err) {
        store.dispatch({ type: SET_SAVING, isSaving: false }); // Finaliza la carga
        console.error("Error al eliminar el archivo:", err);
        throw err; // Lanza el error
    }
}

